import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    this.mediaQueryListener = () => {
      if (!this.storedTheme()) this.applyTheme(this.mediaQuery.matches ? 'dark' : 'light')
    }
    this.mediaQuery.addEventListener('change', this.mediaQueryListener)
    this.updateIcon(document.documentElement.getAttribute('data-theme'))
  }

  disconnect() {
    this.mediaQuery.removeEventListener('change', this.mediaQueryListener)
  }

  toggle(event) {
    event.preventDefault()
    var current = document.documentElement.getAttribute('data-theme')
    var next = current === 'dark' ? 'light' : 'dark'
    this.storeTheme(next)
    this.applyTheme(next)
  }

  applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme)
    this.updateIcon(theme)
    document.dispatchEvent(new CustomEvent('themechange', { detail: { theme: theme } }))
  }

  updateIcon(theme) {
    if (!this.hasIconTarget) return
    this.iconTarget.classList.toggle('fa-sun', theme === 'dark')
    this.iconTarget.classList.toggle('fa-moon', theme !== 'dark')
  }

  storedTheme() {
    try { return localStorage.getItem('theme') } catch (e) { return null }
  }

  storeTheme(theme) {
    try { localStorage.setItem('theme', theme) } catch (e) {}
  }
}
